import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const ChangeMunicipalityModal = ({
    onAccept, onCancel, show, ...props
}) => (
    <Modal
        show={show}
        onHide={onCancel}
        {...props}
        aria-labelledby="contained-modal-title-lg"
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
                <FormattedMessage id="modal-change-municipality-title" defaultMessage="Delivery zone" />
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div>
                <div>
                    <FormattedMessage
                        id="modal-change-municipality-text1"
                        defaultMessage="You are making a change in the delivery zone initially selected and your cart will be empty."
                    />
                    &nbsp;
                    <FormattedMessage
                        id="modal-change-municipality-text2"
                        defaultMessage="Please be sure to select the correct province and municipality where we must deliver your order before you place your order."
                    />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={() => onAccept()}>
                <FormattedMessage id="empty-cart" defaultMessage="Empty Cart" />
            </Button>
            <Button onClick={() => onCancel()}>
                <FormattedMessage id="modal-change-municipality-button-cancel" defaultMessage="Cancel" />
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ChangeMunicipalityModal;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/modals/change-municipality-modal.jsx
 **/